import React, { Component } from 'react';
import { connect } from 'react-redux';
import LargeHeader from '../largeheader';
import SmallHeader from '../smallheader';


class Header extends Component {

    constructor(props){
        super(props)
    }

    render() {
        return this.props.browser
            ? ( this.props.browser.greaterThan.medium ? <SmallHeader {...this.props}/> : <SmallHeader  {...this.props}/>  )
            : ( <div></div> )
    }
}

export default connect( 
    state =>({
        browser: state.browser,
    }),
    dispatch => { 
        return { 
        } 
    }
)(Header);



// WEBPACK FOOTER //
// ./src/components/header/index.js